<template>
<div class="chapter">
<div class="inner_page">
<h1>The Outdoor Girls</h1>
<h1 class="sigil_not_in_toc">At Bluff Point</h1>
<h2 class="sigil_not_in_toc">Or a Wreck and a Rescue</h2>
<h2 class="sigil_not_in_toc">Laura Lee Hope</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?17d9a3ce